export default "__VITE_ASSET__CMdkhV4Q__"